// icons/MiniClockIcon.js

const MiniClockIcon = ({
  size = 28,
  bgColor = "#E9FFF8",
  stroke = "#18C3A5"
}) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "9999px",
        background: bgColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <svg
        width={48}
        height={48}
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle
          cx="12"
          cy="12"
          r="8"
          stroke={stroke}
          strokeWidth="2"
        />

        <path
          d="M12 8V12L15 14"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default MiniClockIcon;